// Domain-aware configuration utility
// Centralised branding / URL helpers for the Advicelink app.

export const APP_DISPLAY_NAME = 'Advicelink';

export const getCurrentDomain = () => window.location.hostname;

export const isAdviceLinkDomain = () => getCurrentDomain().includes('advicelink.org');

export const getAppName = () => APP_DISPLAY_NAME;

export const getDisplayAppName = () => APP_DISPLAY_NAME;

export const getAppShortName = () => APP_DISPLAY_NAME;

export const getWebsiteUrl = () => 'https://advicelink.org';

export const getEmailDomain = () => 'advicelink.org';

export const getFromEmail = () => `noreply@${getEmailDomain()}`;

export const getAppDescription = () =>
  'Professional financial advice and client management platform';

export const getPageTitle = () => APP_DISPLAY_NAME;

export const getFullPageTitle = () => `${getPageTitle()} - Financial Adviser Portal`;

export const domainConfig = {
  current: getCurrentDomain(),
  isAdviceLink: isAdviceLinkDomain(),
  appName: getAppName(),
  appShortName: getAppShortName(),
  websiteUrl: getWebsiteUrl(),
  emailDomain: getEmailDomain(),
  fromEmail: getFromEmail(),
  appDescription: getAppDescription(),
  pageTitle: getPageTitle(),
  fullPageTitle: getFullPageTitle()
};

export default domainConfig;
